import { getMainRoles, Role } from './role'

export enum Audience {
  HOMEBUYER = 'homebuyer',
  AGENT = 'agent',
  LENDER = 'lender',
}

/**
 * The audience a user belongs to, derived from their main role. A mortgage
 * broker counts as a lender, and anyone with neither a lender nor an agent
 * role (including employees) is a homebuyer.
 */
export const getAudienceFromRoles = (roles: string[] = []): Audience => {
  switch (getMainRoles(roles)) {
    case Role.LENDER:
      return Audience.LENDER
    case Role.AGENT:
      return Audience.AGENT
    default:
      return Audience.HOMEBUYER
  }
}
